import useSearchFilters from './useSearchFilters';

export default useSearchFilters;
